import React, {useState} from 'react';
import './App.css';
import {PhoneButton} from "./PhoneButton";
import {BookOnlineButton} from "./BookOnlineButton";
import {CallPopup} from "./CallPopup";
import {ChevronDown} from "lucide-react";


function App() {
    const [popupShown, setPopupShown] = useState(false);
    return (
        <div className="App">
            <div className="sudbury-guitars-banner">
                <a href="https://sudburyguitars.com">Checkout our repair shop <span style={{textDecoration: "underline"}}>Sudbury Guitars</span> &gt;&gt;</a>
            </div>
            <header className="App-header">
                <h1>Sudbury School of Music</h1>
                <p>Serving Sudbury, Wayland, and the metro west since 2012, we provide premium and personalized music lessons to students of all ages. We offer guitar, bass, drums, piano, and more.</p>
                <div style={{display: 'flex', gap: '12px', flexWrap: 'wrap', justifyContent: 'center'}}>
                    <PhoneButton desktopAction={(() => setPopupShown(true))}/>
                    <BookOnlineButton />
                </div>
                <div className="down-arrows" onClick={() => document.querySelector('.App-main')?.scrollIntoView({behavior: 'smooth'})}>
                    <ChevronDown size={32} />
                    <ChevronDown size={32} style={{marginTop: '-8px'}} />
                </div>
            </header>
            <main className="App-main">
                <section className="profiles">
                    <div className="profile">
                        <img src={"/img/peter.jpg"}/>
                        <p>
                            Peter Wiernik opened Sudbury School of Music after over 2 decades of teaching private guitar lessons.
                            He graduated from Berklee College of Music with a Bachelor of Music in Performance and Composition and Boston University with a Masters in Music.
                            Peter's principal instrument is the guitar, but he also teaches piano, drums, clarinet, and violin.
                        </p>
                    </div>
                    <div className="profile">
                        <img src={"/img/alison.jpg"}/>
                        <p>
                            Alison Keslow is an instructor at Sudbury School of Music and professional musician.
                            She graduated from Berklee College of Music with a Bachelor of Music in Musical Education
                            and Boston University with a Masters in Music. Alison is summer faculty at Berklee, and
                            performs throughout Boston and the greater metro west area with her band, the Alison Keslow
                            Trio. Alison's principal instrument is the bass guitar, but she also teaches piano and flute.
                        </p>
                    </div>
                </section>

                <section className="pricing">
                    <div className="pricing-card">
                        <h1>Starter pack</h1>
                        <h2>$60/lesson for 4 lessons</h2>
                        <h3>Billed as 1 payment of $240</h3>
                        <p>Recommended for new musicians, or those looking to try out a new teacher without a large commitment.</p>
                        <div className="flavor-bar">
                            Most affordable
                        </div>
                    </div>
                    <div className="pricing-card">
                        <h1>Standard pack</h1>
                        <h2>$55/lesson for 10 lessons</h2>
                        <h3>Billed as 1 payment of $550</h3>
                        <p>Recommended for most students.</p>
                        <div className="flavor-bar">
                            Most popular
                        </div>
                    </div>
                    <div className="pricing-card">
                        <h1>Semester pack</h1>
                        <h2>$47.50/lesson for 20 lessons</h2>
                        <h3>Billed as 1 payment of $950</h3>
                        <p>Recommended for students looking to save by commiting to a full semester of music up front.</p>
                        <div className="flavor-bar">
                            Best value
                        </div>
                    </div>
                </section>

                <section className="info">
                    <div className="info-card">
                        <h1>Hours</h1>
                        <div className="hour">
                            <p>Monday</p>
                            <p>10am-8pm</p>
                        </div>
                        <div className="hour">
                            <p>Tuesday</p>
                            <p>10am-8pm</p>
                        </div>
                        <div className="hour">
                            <p>Wednesday</p>
                            <p>10am-8pm</p>
                        </div>
                        <div className="hour">
                            <p>Thursday</p>
                            <p>10am-8pm</p>
                        </div>
                        <div className="hour">
                            <p>Friday</p>
                            <p>10am-8pm</p>
                        </div>
                        <div className="hour">
                            <p>Saturday</p>
                            <p>10am-3pm</p>
                        </div>
                    </div>

                    <div className="info-card">
                        <iframe
                            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3485.566050012673!2d-71.41807002336863!3d42.36076907119288!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89e38f1103300041%3A0xaffc96bb44bb197e!2sSudbury%20School%20of%20Music!5e1!3m2!1sen!2sus!4v1749596318676!5m2!1sen!2sus"
                            width="600" height="450" loading="lazy"
                            referrerPolicy="no-referrer-when-downgrade">
                        </iframe>
                    </div>
                </section>

                <section className="cta">
                    <div className="cta-card">
                        <h1>Give us a call to book a lesson, or learn more about our music school</h1>
                        <div style={{display: 'flex', gap: '12px', flexWrap: 'wrap', justifyContent: 'center'}}>
                            <PhoneButton desktopAction={(() => setPopupShown(true))}/>
                            <BookOnlineButton />
                        </div>
                    </div>
                </section>


            </main>

            <CallPopup
                isOpen={popupShown}
                onClose={() => setPopupShown(false)}
            />

        </div>
    );
}

export default App;
